import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import RadioButtonsGroup from "@app/components/move2Library/RadioButtonsGroup/RadioButtonsGroup"
import { SelectBox } from "@app/components/move2Library/SelectBox/SelectBox"
import { useGetStrings } from "@app/store/service/cmsService"
import {
	useDeleteRelationAddress,
	useGetCountries,
	useGetSalutations,
	useGetTransporterCountries,
	useSaveRelationAddress,
} from "@app/store/service/connectorService"
import { ADRESS_TYPES } from "@app/utils/constants"
import { getTransporterIdsForCountrySelection } from "@app/utils/getTransporterIds"
import { splitStreetToParts } from "@app/utils/stringUtils"
import { Modal, useModal, useViewport } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useCallback, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { MyParadiseDeleteModal } from "../MyParadiseDeleteModal/MyParadiseDeleteModal"
import "./MyParadiseAddressModal.css"

const MyParadiseAddressModal = ({ address, openModalAfterUpdate, addressTypeId, afterSave, useTransporterCountries }) => {
	const { sm } = useViewport()
	const [showDeleteDialog, setShowDeleteDialog] = useState(false)
	const { hideModal, showModal } = useModal()

	const { data: salutations } = useGetSalutations()
	const formattedOrder = useSelector(state => state.order.formattedOrder)
	const { data: countries } = useTransporterCountries
		? // eslint-disable-next-line react-hooks/rules-of-hooks
			useGetTransporterCountries({ transporterIds: getTransporterIdsForCountrySelection(formattedOrder) })
		: // eslint-disable-next-line react-hooks/rules-of-hooks
			useGetCountries()
	const [saveAddress, { isLoading: saveAddressLoading }] = useSaveRelationAddress()
	const [deleteAddress, { isLoading: deleteAddressLoading }] = useDeleteRelationAddress()
	const {
		data: {
			placeholderFirstName,
			placeholderLastName,
			placeholderAddress,
			placeholderPostalCode,
			placeholderEMail,
			placeholderCity,
			placeholderAddressAddition,
			labelSalutation,
			placeholderCountry,
			placeholderCompany,
			requiredFields,
			pleaseSelect,
			buttonDeleteAddress,
			buttonSave,
			errorInputMissingFirstName,
			errorInputMissingLastName,
			errorInputMissingPostalCode,
			errorInputMissingCity,
			errorInputMissingSalutation,
			errorInputMissingAddress,
			errorInputMissingCountry,
			errorInputInvalidAddress,
			errorInputMissingEmail,
			invoiceAddress,
			deliveryAddress,
			buttonClose,
		},
	} = useGetStrings(undefined, { defaultData: {} })

	const {
		register,
		handleSubmit,
		formState: { errors },
		getValues,
		setValue,
	} = useForm({
		mode: "onTouched",
	})

	useEffect(() => {
		if (countries && (!getValues().countryId || getValues().countryId.length === 0)) {
			setValue("countryId", "60")
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (address) {
			const street = address.address && address.houseNo ? `${address.address} ${address.houseNo}` : undefined
			setValue("salutation", address.genderId ? address.genderId + "" : undefined)
			setValue("firstName", address.firstName)
			setValue("email", address.email)
			setValue("lastName", address.lastName)
			setValue("phoneNo", address.phoneNo)
			setValue("street", street)
			setValue("zipCode", address.zipCode)
			setValue("city", address.city)
			setValue("countryId", address.countryId)
			setValue("companyName", address.companyName)
			setValue("addressAddition", address.addressAddition)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [address])

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const onSaveClick = useCallback(async () => {
		handleSubmit(async data => {
			data.genderId = parseInt(data.salutation)
			const streetObj = splitStreetToParts(data.street)
			data = {
				...(address || { addressTypeId: addressTypeId }),
				...data,
				address: streetObj.street,
				houseNo: streetObj.number + (streetObj.letter || ""),
			}
			delete data.relation
			let result = await saveAddress({ address: data }).unwrap()
			if (result) {
				hideModal()
				afterSave && afterSave(result)
				openModalAfterUpdate && showModal(openModalAfterUpdate)
			}
		})()
	})

	return (
		<Modal className="customModal" ariaLabelledBy="new-billing-address-modal-title">
			<Modal.Closer
				onClick={() => {
					if (openModalAfterUpdate) {
						showModal(openModalAfterUpdate)
					} else {
						hideModal()
					}
				}}
				ariaLabel={buttonClose}
			/>
			<Modal.Header>
				<h2 id="new-billing-address-modal-title" className="h-without-default-style">
					{addressTypeId === ADRESS_TYPES.DELIVERY ? deliveryAddress : invoiceAddress}
				</h2>
			</Modal.Header>
			{showDeleteDialog && (
				<div style={{ position: "absolute", backgroundColor: "rgba(0,0,0,0.7)" }} className="h-100 w-100 flex flex-center z-9">
					<MyParadiseDeleteModal
						onClose={() => {
							setShowDeleteDialog(false)
						}}
						onDelete={async () => {
							const result = await deleteAddress({ addressId: address.addressId, addressToken: address.addressToken })
							if (result) {
								hideModal()
								openModalAfterUpdate && showModal(openModalAfterUpdate)
							}
						}}
						isAddress
					/>
				</div>
			)}
			<Modal.Body>
				<form aria-labelledby="new-billing-address-modal-title">
					<div className="myParadiseDataModal__inputRow myParadiseDataModal__inputRow--3">
						<RadioButtonsGroup
							label={labelSalutation}
							options={salutations}
							errors={errors}
							formRegister={register("salutation", {
								required: {
									value: true,
									message: errorInputMissingSalutation,
								},
							})}
						/>
					</div>

					<div className="myParadiseDataModal__inputRow myParadiseDataModal__inputRow--3">
						<div>
							<Input
								type="text"
								label={placeholderCompany}
								formRegister={register("companyName", {
									required: {
										value: false,
									},
								})}
								errors={errors}
							/>
						</div>
					</div>
					<div className="myParadiseDataModal__inputRow myParadiseDataModal__inputRow--3">
						<div>
							<Input
								type="text"
								label={placeholderEMail + "*"}
								formRegister={register("email", {
									required: {
										value: true,
										message: errorInputMissingEmail,
									},
								})}
								errors={errors}
							/>
						</div>
					</div>

					<div className="myParadiseDataModal__inputRow myParadiseDataModal__inputRow--3">
						<div>
							<Input
								name="firstname"
								type="text"
								label={placeholderFirstName + "*"}
								autocomplete="given-name"
								formRegister={register("firstName", {
									required: {
										value: true,
										message: errorInputMissingFirstName,
									},
								})}
								errors={errors}
							/>
						</div>
						<div>
							<Input
								name="lastname"
								type="text"
								label={placeholderLastName + "*"}
								autocomplete="family-name"
								formRegister={register("lastName", {
									required: {
										value: true,
										message: errorInputMissingLastName,
									},
								})}
								errors={errors}
							/>
						</div>
					</div>

					<div className="myParadiseDataModal__inputRow myParadiseDataModal__inputRow--1_2">
						<Input
							name="postalCode"
							type="text"
							label={placeholderPostalCode + "*"}
							autocomplete="postal-code"
							formRegister={register("zipCode", {
								required: {
									value: true,
									message: errorInputMissingPostalCode,
								},
							})}
							errors={errors}
						/>
						<Input
							name="city"
							type="text"
							label={placeholderCity + "*"}
							autocomplete="address-level2"
							formRegister={register("city", {
								required: {
									value: true,
									message: errorInputMissingCity,
								},
							})}
							errors={errors}
						/>
					</div>

					<div className="myParadiseDataModal__inputRow myParadiseDataModal__inputRow--3">
						<Input name="addressAddition" type="text" label={placeholderAddressAddition} formRegister={register("addressAddition", {})} errors={errors} />
						<Input
							name="street"
							type="text"
							label={placeholderAddress + "*"}
							autocomplete="on"
							formRegister={register("street", {
								required: {
									value: true,
									message: errorInputMissingAddress,
								},
								validate: value => {
									try {
										splitStreetToParts(value)
										return true
									} catch {
										return errorInputInvalidAddress
									}
								},
							})}
							errors={errors}
						/>
					</div>

					<div className="myParadiseDataModal__inputRow myParadiseDataModal__inputRow--3">
						<SelectBox
							classname="selectbox border rounded-1 fill"
							autocomplete="country"
							formRegister={register("countryId", {
								required: {
									value: true,
									message: errorInputMissingCountry,
								},
							})}
							onChange={e => {
								setValue("countryId", e.target.value)
							}}
							errors={errors}
							label={placeholderCountry + "*"}
						>
							<option value="" disabled style={{ display: "none" }}>
								{pleaseSelect}*
							</option>
							{countries &&
								countries.map(country => {
									return (
										<option key={country.countryId} value={country.countryId}>
											{country.country}
										</option>
									)
								})}
						</SelectBox>
					</div>
					<div className="mt-3 regular color-fg-default" aria-hidden="true">
						* {requiredFields}
					</div>
				</form>
			</Modal.Body>

			<Modal.Footer>
				<div className={sm ? "flex flex-column flex-align-center mt-4 mb-2" : "flex flex-justify-between mt-4 mb-2 "}>
					{address && (
						<Button style="secondary" className={sm && "mb-3"} onClick={() => setShowDeleteDialog(true)} isLoading={deleteAddressLoading}>
							{buttonDeleteAddress}
						</Button>
					)}

					<Button style="primary" onClick={onSaveClick} isLoading={saveAddressLoading}>
						{buttonSave}
					</Button>
				</div>
			</Modal.Footer>
		</Modal>
	)
}

export default MyParadiseAddressModal
